import { render, staticRenderFns } from "./channel-batch-edit.vue?vue&type=template&id=4b605d16&scoped=true&"
import script from "./channel-batch-edit.vue?vue&type=script&lang=js&"
export * from "./channel-batch-edit.vue?vue&type=script&lang=js&"
import style0 from "./channel-batch-edit.vue?vue&type=style&index=0&id=4b605d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b605d16",
  null
  
)

export default component.exports